import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Fade } from "react-awesome-reveal";
import "swiper/css";

import SectionTitle from "./SectionTitle";
import SliderLine from "./SliderLine";

import bannerMountain from "../../img/home/banner-mountain.webp";
import bannerCloud from "../../img/home/banner-cloud.webp";

const CARDS = [
  { titleKey: "speed.card1.title", textKey: "speed.card1.text" },
  { titleKey: "speed.card2.title", textKey: "speed.card2.text" },
  { titleKey: "speed.card3.title", textKey: "speed.card3.text" },
  { titleKey: "speed.card4.title", textKey: "speed.card4.text" },
  { titleKey: "speed.card5.title", textKey: "speed.card5.text" },
  { titleKey: "speed.card6.title", textKey: "speed.card6.text" },
];

function SpeedCard({ titleKey, textKey, t }) {
  return (
    <Fade triggerOnce direction="up" duration={600} className="flex-1 min-w-0">
      <div
        className="relative flex flex-col gap-[12px] p-[25px] lg:p-[32px] rounded-[20px] overflow-hidden min-h-[150px] lg:min-h-[164px] hover:-translate-y-[4px] transition-transform duration-300"
        style={{
          background: "rgba(22,36,56,0.8)",
          backdropFilter: "blur(4px)",
          border: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <div className="absolute left-0 top-0 bottom-0 w-[4px] bg-[#4da6ff]" />
        <div className="check-icon-blue">
          <Check className="w-[14px] h-[14px] text-[#4da6ff]" strokeWidth={2.5} />
        </div>
        <p className="font-20-16">{t(titleKey)}</p>
        <p className="font-16-14-dark">{t(textKey)}</p>
      </div>
    </Fade>
  );
}

function Speed() {
  const { t } = useTranslation();
  const swiperRef = useRef(null);
  const [current, setCurrent] = useState(0);

  return (
    <section
      className="mt relative overflow-hidden py-[35px] lg:py-[60px]"
      style={{ backgroundImage: "linear-gradient(102deg, #232e3e 8%, #31435c 98%)" }}
    >
      {/* Горы внизу секции */}
      <img
        src={bannerMountain}
        alt=""
        aria-hidden
        className="hidden sm:block absolute bottom-0 left-0 w-full h-[137px] lg:h-[287px] object-cover object-top pointer-events-none select-none"
      />
      {/* Облака */}
      <img
        src={bannerCloud}
        alt=""
        aria-hidden
        className="hidden lg:block absolute left-[57%] top-[-160px] w-[74%] opacity-20 pointer-events-none select-none"
      />
      <img
        src={bannerCloud}
        alt=""
        aria-hidden
        className="hidden lg:block absolute left-[-30%] top-[-20px] w-[74%] opacity-20 pointer-events-none select-none"
      />

      <div className="glcontainer relative">
        <SectionTitle
          title1={t("speed.title1")}
          title2={t("speed.title2")}
          text={t("speed.subtitle")}
          dark
          className="mb-[35px] lg:mb-[40px] mx-auto"
        />

        {/* Desktop: 2 ряда по 3 карточки с разделителем */}
        <div className="hidden sm:flex flex-col gap-[24px]">
          <div className="flex flex-col lg:flex-row gap-[24px]">
            {CARDS.slice(0, 3).map((card, i) => (
              <SpeedCard key={i} titleKey={card.titleKey} textKey={card.textKey} t={t} />
            ))}
          </div>
          <div className="h-px bg-[rgba(255,255,255,0.08)]" />
          <div className="flex flex-col lg:flex-row gap-[24px]">
            {CARDS.slice(3).map((card, i) => (
              <SpeedCard key={i} titleKey={card.titleKey} textKey={card.textKey} t={t} />
            ))}
          </div>
        </div>

        {/* Мобильный слайдер */}
        <div className="sm:hidden">
          <Swiper
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            onSlideChange={(swiper) => setCurrent(swiper.realIndex)}
            spaceBetween={16}
            slidesPerView={1}
            grabCursor
          >
            {CARDS.map((card, i) => (
              <SwiperSlide key={i}>
                <SpeedCard titleKey={card.titleKey} textKey={card.textKey} t={t} />
              </SwiperSlide>
            ))}
          </Swiper>
          <SliderLine
            current={current}
            total={CARDS.length}
            onPrev={() => swiperRef.current?.slidePrev()}
            onNext={() => swiperRef.current?.slideNext()}
            dark
          />
        </div>
      </div>
    </section>
  );
}

export default Speed;
